import {WarehouseTargetData} from '@/services/MockData/Products/Fullfillment/WarehouseTargetData'
import {WarehouseUploadHistoryData} from '@/services/MockData/Products/Fullfillment/WarehouseUploadHistoryData'
import {API_VERSION} from '@/utils/constants/commonConstants'

export const WAREHOUSE_CONFIG = {
  WAREHOUSE_TARGETS: {
    endPoint: 'warehouse-targets',
    mockData: WarehouseTargetData,
    version: API_VERSION.V1,
  },
  WAREHOUSE_UPLOAD_HISTORY: {
    endPoint: 'warehouse-upload-history',
    mockData: WarehouseUploadHistoryData,
    version: API_VERSION.V1,
  },
}
